export const LOAD_COMMENT = 'LOAD_COMMENT';
export const LIKE = 'LIKE';
export const DISLIKE = 'DISLIKE';
